import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { LanguageService } from 'vhobjects-service/src/services';
import { AtwSelectAdmin } from 'vhobjects-admin';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService} from 'vhobjects-service/src/services';
import { ThemeService } from 'vhobjects-service/src/services';


@Component({
  selector: 'atw-select-config',
  templateUrl: './select-config.component.html',
  styleUrls: ['./select-config.component.scss']
})
export class AtwSelectConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  newFields = [];
  /**
     * Hàm này dùng để cho phép mở menu config .
     * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
     * @param: value
     */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false, menu7: false, menu8: false
  };
  constructor(
    private nzModalService: NzModalService,
    private languageService: LanguageService,
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public functionService: FunctionService,
    public themeService: ThemeService,
  ) { }

  ngOnInit() {
    this.vhQueryAutoWeb.getNewFields_byFields({ id_main_sector: { $eq: 'contact' } })
    .then((newfields: any) => {
      this.newFields = newfields;
    });
  }

  openHandler(value: string): void {
    Object.keys(this.openMap).forEach(key => {
      if (key !== value) this.openMap[key] = false;
    });
  }




  handleAddData() {

    const modal: NzModalRef = this.nzModalService.create({
      nzTitle: this.languageService.translate('chinh_sua_noi_dung'),
      nzWidth: '700px',
      nzContent: AtwSelectAdmin,
      nzComponentParams: {
        data: this.objectChoosing,
        staticdata: this.staticdata,
        type: 'page'
      },
      nzFooter: null,
    });
    modal.afterClose.subscribe(result => {
      // this.vhEventMediator.notifyOnConfigChanged({
      //   status: 'config-changed',
      //   code: this.objectChoosing._id,
      // });
    });
  }

  // hàm lưu giá trị của sản phẩm khi thay đổi
  onSelectChange(field_custom: any) {
    this.staticdata.value_main_sector = field_custom;
    const findItem = this.newFields.find(e => e.field_custom == field_custom);
    if (findItem) {
      this.staticdata.field_required = findItem.field_required;
      this.staticdata.field_lable = findItem.field_lable;
    }
    this.updateStaticData();
  }

  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      staticdata: this.staticdata
    })
  }

  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_class']: this.class
    })
  }

  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config
    })
  }

  updateWidthAndHeight(newWidth: number): void {
    this.class['select__checkbox']['width'] = `${newWidth}px`;
    // Giữ tỷ lệ 1:1 (hoặc thay đổi logic tùy ý)
    this.class['select__checkbox']['height'] = `${newWidth}px`;
  }
}
